export default "/build/images/foot.png?6733f45d637c17ce3dbf95e83e77a7cf";